module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9DlF1"))).then(() => parcelRequire('1iHdE'));